var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("RecoverAccount", {
        attrs: {
          title: _vm.$t("settings.password.forgotPassword.head"),
          notice: _vm.$t("settings.password.forgotPassword.notice"),
          confirmHint: _vm.$t("settings.password.confirmEmailSent"),
          requestPath: "forgot",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }